import { useCustomerContext } from 'pages/Customer/CustomerContext';
import { useMemo } from 'react';
import { FiPrinter } from 'react-icons/fi';
import { Mixpanel } from 'services/mixpanel';
import { getInvoiceUrl } from 'services/order';
import Banner from 'shared/components/Banner';
import { pdfDownload } from 'shared/helpers/pdfDownload';

const IncomingInvoiceBanner = () => {
  const { customer } = useCustomerContext();
  const order = useMemo(
    () => customer?.contract?.nextOrderWithInvoice,
    [customer],
  );

  const action = async () => {
    Mixpanel.track('customers-principal-downloaded-invoice');
    if (order?.hasInvoiceLink && order.id) {
      try {
        const { data } = await getInvoiceUrl(order.id);
        await pdfDownload(data.url);
      } catch (error) {
        console.error('Erro ao baixar boleto:', error);
      }
    }
  };

  return customer.contract && customer.contract.isInvoice && order ? (
    <Banner
      content="Baixe aqui o boleto do cliente"
      Icon={FiPrinter}
      action={action}
      colorScheme="yellow"
    />
  ) : (
    <></>
  );
};

export default IncomingInvoiceBanner;
